import { useMemo } from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionTitleHomepage from "hooks/form/blocks/useSectionTitleHomepage";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum } from "types/enums";

function SectionTitleHomePageForm({ blockId }: { blockId: BlockEnum }) {
    const { buttonDelete, formHook } = useSectionTitleHomepage();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    const firstText = useMemo(() => {
        if (blockId === BlockEnum.SectionTitleHomePage) {
            return "Prima parte del titolo";
        }

        return "Titolo";
    }, [blockId]);

    const secondText = useMemo(() => {
        if (blockId === BlockEnum.SectionTitleHomePage) {
            return "Seconda parte del titolo";
        }

        return "Sottotitolo";
    }, [blockId]);

    const thirdText = useMemo(() => {
        if (blockId === BlockEnum.SectionTitleHomePage) {
            return "Sottotitolo";
        }

        return "Primo Testo";
    }, [blockId]);

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={firstText}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_one}
                                            setValue={setValue}
                                            path={"text.it.text_one"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={secondText}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_two}
                                            setValue={setValue}
                                            path={"text.it.text_two"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={thirdText}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_three}
                                            setValue={setValue}
                                            path={"text.it.text_three"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={firstText}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_one}
                                            setValue={setValue}
                                            path={"text.en.text_one"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={secondText}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_two}
                                            setValue={setValue}
                                            path={"text.en.text_two"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={thirdText}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_three}
                                            setValue={setValue}
                                            path={"text.en.text_three"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionTitleHomePageForm;
